export default __webpack_public_path__ + "static/media/lock.46f583ee.svg";